import React from "react";
import Navigation from "../../components/Navigation";
import Footer from "../../components/Footer";
import './style.css';

const Cookies = () => {
  return (
    <div className="cookies-page">
      <Navigation />

      {/* Hero Section */}
      <section className="cookies-hero">
        <div className="cookies-hero-container">
          <h1>About Big Cat Graphics and Cookies</h1>
          <p>Where imagination meets exceptional design</p>
          <p>By default, Firebase Hosting does not set tracking or marketing cookies for static sites. However, it may use a session cookie (__session) if needed for technical delivery Firebase Hosting Documentation. for more info, see the Firebase Hosting documentation and our personal <a href="/privacy">Privacy Policy</a>.</p>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Cookies;
